const App = require('swa-layout/app');
const AutocompleteContextProvider = require("swa-components-core/autocomplete-context-provider");
const React = require('react');
const withNearbyAirport = require('swa-app-base/nearby-airport');
const WithNearbyAirportFeature = withNearbyAirport(AutocompleteContextProvider);

class CorporateLandingHomePageApp extends React.Component {

    render = () => (
        <WithNearbyAirportFeature>
            <App location={this.props.location}>
                {this.props.children}
            </App>
        </WithNearbyAirportFeature>
    );
}

module.exports = CorporateLandingHomePageApp;
